import { SVGAttributes } from "react";

export function SuccessIcon(props: SVGAttributes<SVGSVGElement>) {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="1" y="1" width="14" height="14" rx="7" fill="#59BB5A" />
      <g clipPath="url(#clip0_8945_66720)">
        <path
          d="M6.75091 9.7373L5.30508 8.29147C5.14258 8.12897 4.88008 8.12897 4.71758 8.29147C4.55508 8.45397 4.55508 8.71647 4.71758 8.87897L6.45924 10.6206C6.62174 10.7831 6.88424 10.7831 7.04674 10.6206L11.4551 6.2123C11.6176 6.0498 11.6176 5.7873 11.4551 5.6248C11.2926 5.4623 11.0301 5.4623 10.8676 5.6248L6.75091 9.7373Z"
          fill="#FDFDFE"
        />
      </g>
      <defs>
        <clipPath id="clip0_8945_66720">
          <rect width="10" height="10" fill="white" transform="translate(3 3)" />
        </clipPath>
      </defs>
    </svg>
  );
}
